export type Dictionary<T> = {
  [Key: string]: T
}

export enum UserRole {
  BriqProfileManager = 'BriqProfileManager',
  BriqUser = 'BriqUser',
  BRIQBuyReportPermission = 'BRIQBuyReportPermission',
  BRIQBulkImport = 'BRIQBulkImport'
}
